export enum SecurityUserMode {
    SINGLE = 'single',
    MULTI = 'multi',
    AD = 'ad', // Active Directory
    SAML = 'saml',
    OAUTH2 = 'oauth2',
}
